import { CheckCircleFilled, LoadingOutlined } from '@ant-design/icons'
import { Empty, message, Pagination } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import {
  getVacationSettlementList,
  updatePayoutStatus,
} from '../../api/aops.vacation.api'
import { formatLeave } from '../../utils/calcuateAnnualLeave'
import './vacationPage.scss'
const VacationSettlementTable = (props = {}) => {
  const { shouldRefresh, setShouldRefresh } = props
  const [settlementList, setSettlementList] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize] = useState(5)
  const [paginationInfo, setPaginationInfo] = useState({
    totalElements: 0,
    totalPages: 0,
  })

  // Map manage status to Korean
  const getManageStatusLabel = (manageStatus) => {
    const mapping = {
      NORMAL: '정상',
      UPCOMING: '예정',
      REQUIRED: '필요',
      URGENT: '긴급',
    }
    return mapping[manageStatus] || manageStatus
  }

  const fetchSettlementList = async (page = 0) => {
    setLoading(true)
    try {
      const res = await getVacationSettlementList({
        page,
        size: pageSize,
        sort: 'id,DESC',
      })
      setSettlementList(res?.content || [])
      setPaginationInfo({
        totalElements: res?.totalElements || 0,
        totalPages: res?.totalPages || 0,
      })
    } catch (error) {
      console.error('Failed to fetch settlement list:', error)
      setSettlementList([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchSettlementList(currentPage - 1)
  }, [currentPage, shouldRefresh])

  const handlePageChange = (page) => {
    setCurrentPage(page)
  }

  const handlePayoutStatusChange = async (settlementId, userId) => {
    Swal.fire({
      title: '연차 지급 상태 변경',
      text: '연차 지급 상태를 변경하시겠습니까?',
      icon: 'question',
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        handlePayoutStatusUpdate(settlementId, userId)
      }
    })
  }

  const handlePayoutStatusUpdate = async (settlementId, userId) => {
    const payload = {
      settlementId: settlementId,
      userId: userId,
    }
    setShouldRefresh(false)
    try {
      const res = await updatePayoutStatus(payload)
      message.success('연차 지급 상태가 변경되었습니다.')
      // 업데이트 후 현재 페이지의 데이터를 다시 불러옴
      await fetchSettlementList(currentPage - 1)
      setShouldRefresh(true)
    } catch (error) {
      console.error('Failed to update payout status:', error)
      message.success('이미 보상 처리가 완료된 항목입니다.')
    }
  }

  const openErrorModal = (error) => {
    Swal.fire({
      customClass: { popup: 'custom-alert' },
      icon: 'error',
      title: '에러 발생',
      text: error.response.data.detail[1].description,
    })
  }

  return (
    <section className="vacation-box half-width">
      <div className="vacation-history-header-wrapper">
        <div className="vacation-history-header">연차 정산 리스트</div>
      </div>
      <div className="table-wrapper">
        <table className="vacation-history-table">
          <thead className="detail-list-thead">
            <tr>
              <th>이름</th>
              <th>상태</th>
              <th>만료일</th>
              <th>소멸 연차</th>
              <th>지급 유/무</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan={5}
                  style={{ textAlign: 'center', padding: '40px' }}
                >
                  <LoadingOutlined />
                </td>
              </tr>
            ) : settlementList && settlementList.length > 0 ? (
              settlementList.map((item) => {
                return (
                  <tr
                    key={`${item.id}-${item.userId}-settlement`}
                    className="no-hover"
                  >
                    <td
                      style={{
                        fontSize: 16,
                        fontWeight: 700,
                        color: '#191A1C',
                      }}
                    >
                      {item.userName || `사용자 ${item.userId}`}
                    </td>
                    <td>
                      <div
                        className={`table-tag-item ${item.manageStatus?.toLowerCase() || ''}`}
                      >
                        {getManageStatusLabel(item.manageStatus)}
                      </div>
                    </td>
                    <td>
                      {item.expiryDate
                        ? dayjs(item.expiryDate).format('YY.MM.DD')
                        : '-'}
                    </td>
                    <td>{formatLeave(item.unusedDays) || 0}</td>
                    <td>
                      {item.payoutStatus === 'COMPLETED' ? (
                        <div
                          onClick={() => {
                            handlePayoutStatusUpdate(item.id, item.userId)
                          }}
                        >
                          <CheckCircleFilled
                            style={{
                              color: '#117FFA',
                              fontSize: 20,
                              cursor: 'pointer',
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          onClick={() =>
                            handlePayoutStatusChange(item.id, item.userId)
                          }
                        >
                          <CheckCircleFilled
                            style={{
                              color: '#CED5DB',
                              fontSize: 20,
                              cursor: 'pointer',
                            }}
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td
                  colSpan={5}
                  style={{ textAlign: 'center', padding: '40px' }}
                >
                  <Empty description="연차 정산 내역이 없습니다." />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {paginationInfo.totalElements > 0 && (
        <div className="pagination-wrapper">
          <Pagination
            current={currentPage}
            total={paginationInfo.totalElements}
            pageSize={pageSize}
            onChange={handlePageChange}
            showSizeChanger={false}
            showQuickJumper={false}
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} / 총 ${total}개`
            }
          />
        </div>
      )}
    </section>
  )
}

export default VacationSettlementTable
